export class FunctionUtils {
    /**
     * RegExp which is detecting all character not handled by windows operating system
     */
    static readonly FORBIDDEN_CHARACTERS_REG_EXP = /[/\\*"?<>|]/g;

    static isDefined(x: any): boolean {
        return x !== undefined && x != null;
    }

    static isNotDefined(x: any): boolean {
        return x === undefined || x == null;
    }

    static isNotDefinedOrEmptyString(x: any): boolean {
        return this.isNotDefined(x) || x === '' ;
    }

    /**
     * Convert a Date in any object if defined
     *
     * @param xDate the date to convert
     * @returns the converted date
     */
    static convertToDate(xDate: number|Date|string): Date|null {
        return this.isDefined(xDate) ? new Date(xDate) : null;
    }

    /**
     * Convert the date to ISO format
     *
     * @param xDate the date to convert
     * @returns the converted date
     */
    static convertDateToIsoFormat(xDate: number|Date|string): string|null {
        return this.isDefined(xDate) ? new Date(xDate).toISOString() : null;
    }

    /**
     * Remove all forbidden char which is not handled by windows operating system for file or folder
     *
     * @param fileName       the file name where to remove the forbidden character
     * @param characterToSet the chararacter to replace at the place of the forbidden characters
     * @returns the file name without the fobidden characters
     */
    static removeForbiddenCharacterForFile(fileName: string, characterToSet: string): string {
        return fileName?.replaceAll(this.FORBIDDEN_CHARACTERS_REG_EXP, characterToSet) ?? '';
    }
}
